import MegaMenu from '../__header/MegaMenu';
import MobileHeader from '../__header/mobileHeader';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import vhUnit from '../__utils/vhUnit';
import AlertBar from '../__header/AlertBar';
import Inputs from '../__header/Inputs';
 import langSwitch from '../__utils/langSwitch';
const headerMobile = new MobileHeader();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		MegaMenu.init();
		headerMobile.init();
		Accordion.init();
		Video.init();
		mirrorHover();
		smoothScroll();
		Tables.init();
		vhUnit();
		AlertBar();
		Inputs();
		langSwitch();
	},
	loaded() {
		document.querySelector('body').classList.add('page-has-loaded');
		Forms();
		vhUnit();
	},
	resized() {
		headerMobile.resized();
		Tables.toggleShadow();
		vhUnit();
	},
	scrolled() {
		$(window).scroll(function() {    
			var scroll = $(window).scrollTop();
		
			if (scroll >= 5) {
				$(".block-header").addClass("darkHeader");
			} else {
				$(".block-header").removeClass("darkHeader");
			}
		});
	},
	keyDown() {},
	mouseUp(e) {
		headerMobile.hideOutsideClick(e);
	},
}; 	
export default controller; 
